export default "__VITE_ASSET__1330a104__"